import React, { FunctionComponent } from 'react';
import './testimonial.scss';

type TestimonialProps = {
    name: string;
    company?: string;
    comment: string;
};

const Testimonial: FunctionComponent<TestimonialProps> = ({
    name,
    company,
    comment
}) => (
    <div className="testimonial">
        <div className="testimonial-content">
            <p>"{comment}"</p>
        </div>
        <div className="testimonial-author">
            <p className="name">{name}</p>
            {company && <p className="company">{company}</p>}
        </div>
    </div>
);

export default Testimonial; 